import ListErrors from '../components/ListErrors'
import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import {
    UPDATE_FIELD_AUTH,
    GET_PIN_CODE,
    LOGIN_PAGE_VERIFY_PIN_CODE,
    VERIFY_PIN_CODE_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onChangeCode: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'code', value }),
    onGetPinCode: (payload, userKey, phone) => {
        dispatch({ type: GET_PIN_CODE, payload, userKey, phone })
    },
    onCheckPinCode: (payload, userKey, phone) => {
        dispatch({ type: LOGIN_PAGE_VERIFY_PIN_CODE, payload, userKey, phone })
    },
    onUnload: () =>
        dispatch({ type: VERIFY_PIN_CODE_UNLOADED })
})

class Verification extends React.Component {
    constructor() {
        super()
        this.state = {
            userKey: null,
            phone: null,
        }
        this.changeCode = ev => this.props.onChangeCode(ev.target.value)
        this.checkPinCode = (code) => ev => {
            ev.preventDefault()
            const payload = agent.Auth.verifyPinCode(this.state.userKey, code, 'login');
            this.props.onCheckPinCode(payload)
        }
    }
    componentWillMount(props) {
        if (this.props.userKey) {
            Object.assign(this.state, {
                userKey: this.props.userKey,
                phone: this.props.phone,
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        const code = this.props.code || ''
        const inProgress = this.props.inProgress
        return (
            <div className="notice">
                <h1>Verification Code</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.checkPinCode(code)}>
                    <fieldset className="form">
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="code"
                                value={code}
                                maxLength={6}
                                onChange={this.changeCode} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Sign in
                  </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Verification)



// WEBPACK FOOTER //
// ./src/components/Verification.js